
import { Component, namespace, Vue } from 'bits/vue'
import BaseButton from 'library/v4/components/base-button.vue'
import PadletLogo from 'vuecomponents/PadletLogo.vue'

const browser = namespace('browser')

@Component({
  components: {
    PadletLogo,
    BaseButton,
  },
})
export default class FeaturesNavigation extends Vue {
  @browser.State darkMode
  @browser.Getter isPhone
  @browser.Getter isBiggerThanTabletLandscape

  get navigationClass(): object {
    return {
      'nav-tablet-view': !this.isBiggerThanTabletLandscape,
      'nav-mobile-view': this.isPhone,
    }
  }
}
